import { ComponentChildren, h, Ref } from "preact";
import "./dialogStandard.scss";

// todo: need a way to connect buttons inside it to close the containing dialog

interface Props {
    header?: ComponentChildren;
    children: ComponentChildren;
    footer?: ComponentChildren;
}

export function DialogStandardContent(props: Props) {

    return (
        <div class="component-dialog-standard">
            {
                props.header &&
                <header>
                    {
                        props.header
                    }
                </header>
            }
            <div>
                {
                    props.children
                }
            </div>
            {
                props.footer &&
                <footer>
                    {
                        props.footer
                    }
                </footer>
            }
        </div>
    );
}
